import React, {useState} from 'react'
import {Modal, ModalHeader} from 'react-bootstrap'
import LoadingComponent from '../../../../components/LoadingComponent/LoadingComponent'
import {KreirajPakete} from '../../../../api/proizvodnja'
import notifyToast from '../../../../components/Toast/Toast'

const KreirajPaketeModal = ({isModalOpen, setisModalOpen, idProizvodnje}) => {
    const [loading, setLoading] = useState(false)
    const [prikolice, setprikolice] = useState<string>('')
    const [niz, setniz] = useState<string>('')

    const handleOnBtnClick = () => {
        setLoading(true)

        const idList = idProizvodnje.map((item) => item.original.id)

        const data = {
            idProizvodnje: idList[0],
            prikolica: prikolice,
            paketNiz: niz ? niz.split(',').map(x => x.trim()) : [],
        }

        KreirajPakete(data)
            .then((response) => {
                notifyToast(true, response.message)
                setisModalOpen(false)
            })
            .catch((error) => {
                console.error('Error: ', error)
                notifyToast(false, error.response?.data?.message || 'Greška')
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <Modal className='modal-lg' show={isModalOpen} onHide={() => setisModalOpen(false)} centered>
            <ModalHeader closeButton className='fw-bold fs-4'>
                Kreiranje paketa
            </ModalHeader>

            {loading ? (
                <LoadingComponent/>
            ) : (
                <div className='p-8'>

                    {/* INFO */}
                    <div className='alert alert-info mb-6'>
                        Odaberite način kreiranja paketa:
                    </div>

                    <div className='row g-5'>

                        {/* LEFT - PRIKOLICA */}
                        <div className='col-md-6'>
                            <div className={`card p-5 border ${prikolice ? 'border-primary' : ''}`}>
                                <h5 className='fw-bold mb-4'>Opcija 1: Prikolica</h5>

                                <select
                                    className='form-select form-select-lg form-select-solid'
                                    value={prikolice}
                                    onChange={(e) => {
                                        setprikolice(e.target.value)
                                        if (e.target.value) setniz('')
                                    }}
                                >
                                    <option value=''>Odaberi visinu...</option>
                                    <option value='1'>Pr - H = 2700</option>
                                    <option value='2'>Pr - H = 3000</option>
                                </select>

                                <div className='form-text mt-3'>
                                    Sistem automatski generiše pakete prema visini prikolice.
                                </div>
                            </div>
                        </div>

                        {/* RIGHT - NIZ */}
                        <div className='col-md-6'>
                            <div className={`card p-5 border ${niz ? 'border-primary' : ''}`}>
                                <h5 className='fw-bold mb-4'>Opcija 2: Ručni unos (Niz)</h5>

                                <input
                                    type='text'
                                    placeholder='npr. 2,3,1,4'
                                    className='form-control form-control-lg form-control-solid'
                                    value={niz}
                                    onChange={(e) => {
                                        setniz(e.target.value)
                                        if (e.target.value) setprikolice('')
                                    }}
                                />

                                <div className='form-text mt-3'>
                                    Unesite vrijednosti odvojene zarezom.
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ACTIONS */}
                    <div className='d-flex justify-content-end mt-8'>
                        <button
                            className='btn btn-light me-3'
                            onClick={() => setisModalOpen(false)}
                        >
                            Otkaži
                        </button>

                        <button
                            className='btn btn-primary'
                            disabled={loading || (!prikolice && !niz)}
                            onClick={handleOnBtnClick}
                        >
                            {!loading ? 'Kreiraj paket' : 'Molimo sačekajte...'}
                        </button>
                    </div>
                </div>
            )}
        </Modal>
    )
}

export default KreirajPaketeModal